(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector-react/assets/react/actions.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector-react/assets/react/actions.js');

'use strict';

const {
  accountSelector
} = svs.numbergames;
const {
  FETCH_ACCOUNT_LIST,
  SET_ACCOUNT_LIST,
  SET_ACCOUNT,
  INIT
} = svs.numbergames.accountSelectorReact.actionTypes;
const fetchAccountList = () => {
  accountSelector.fetch();
  return {
    type: FETCH_ACCOUNT_LIST
  };
};
const initialize = (list, selectedAccount, selectedAccountChanged) => ({
  type: INIT,
  payload: {
    accounts: list,
    selectedAccount,
    selectedAccountChanged
  }
});
const setAccountList = accountList => ({
  type: SET_ACCOUNT_LIST,
  payload: accountList
});
const setAccount = accountId => {
  accountSelector.setActiveAccount(accountId);
  return {
    type: SET_ACCOUNT,
    payload: accountId
  };
};
svs.numbergames.accountSelectorReact.actions = {
  fetchAccountList,
  setAccountList,
  setAccount,
  initialize
};

 })(window);